import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPixelEvent } from '@/lib/meta-pixel';

/**
 * Fires Meta Pixel PageView on SPA route changes.
 * The initial PageView is fired by initMetaPixel() at load time;
 * this handles subsequent client-side navigations.
 */
export function MetaPixelPageView() {
  const { pathname } = useLocation();

  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the very first render — initMetaPixel already fired PageView
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackPixelEvent('PageView');
  }, [pathname]);

  return null;
}
